import React from "react";
import { Link } from "react-router-dom";
import { SIContext } from "../../Context/SIContext";
import styles from "./LinkButton.module.css";

export function LinkButton({ title, link, Icon }) {
  const { pintaMenu, corPrimary } = React.useContext(SIContext);

  const isActive = pintaMenu.toUpperCase() === title.toUpperCase();
  const activeColor = corPrimary || "#FFB300";

  return (
    <Link to={link} className={`${styles.button} ${isActive ? styles.active : ''}`}>
      <div 
        className={styles.iconContainer} 
        style={isActive ? { color: activeColor } : {}}
      >
        <Icon size={isActive ? 24 : 22} color="currentColor" />
      </div>
      <span 
        className={styles.title} 
        style={isActive ? { color: activeColor, fontWeight: 700 } : {}}
      >
        {title}
      </span>
    </Link>
  );
}

export default LinkButton;
